import { VxeSplit } from 'vxe-pc-ui';
export default {
  name: 'XSplit',
  components: {
    VxeSplit
  },
  props: {},
  setup(props, context) {}
};